import { IModifierQuantityObj } from '../../_store/types'
import {
  ISavedModifier,
  IGroupModifier,
  ISingleModifier,
  IGroupModifierVariant,
} from '../../_types'
import {
  IGroupModifierChangeParams,
  IMaxAmountParams,
  IModifierChangeParams,
} from './types'

const onModifierMaxAmount: IMaxAmountParams = (
  modifier,
  variant,
  orderModifiers,
  setOrderModifiers
) => {
  let isChanged = false

  const maxCount = orderModifiers?.reduce(
    (acc, obj) => (obj?.parent_id ? acc + obj.modifier_quantity : acc),
    0
  )
  const changedModifiers = orderModifiers.map((selModifier) => {
    if (
      selModifier.parent_id === modifier.id &&
      selModifier.modifier_id !== variant?.id &&
      selModifier.modifier_quantity > (selModifier.min_amount || 0) &&
      !isChanged
    ) {
      if (!isNaN(modifier.max_amount) && maxCount < modifier.max_amount) {
        return {
          ...selModifier,
          modifier_quantity: Math.min(
            selModifier.max_amount || 0,
            selModifier.modifier_quantity + 1
          ),
        }
      }
      //  else {
      // return {
      //   ...selModifier,
      //   modifier_quantity: Math.max(
      //     selModifier.min_amount || 0,
      //     selModifier.modifier_quantity - 1
      //   ),
      // }
      // }
    }

    if (
      selModifier.parent_id === modifier.id &&
      selModifier.modifier_id === variant?.id
    ) {
      return {
        ...selModifier,
        modifier_quantity:
          selModifier.modifier_quantity < modifier.max_amount
            ? selModifier.modifier_quantity + 1
            : selModifier.modifier_quantity,
      }
    }

    return selModifier
  })

  const totalCount = changedModifiers.reduce(
    (acc, mod) =>
      mod?.parent_id === modifier?.id ? acc + mod.modifier_quantity : acc,
    0
  )

  if (totalCount >= modifier.max_amount) {
    let decremented = false

    const updatedModifiers = changedModifiers.map((mod) => {
      if (
        mod.modifier_quantity > (mod.min_amount || 0) &&
        !decremented &&
        mod.modifier_id !== variant?.id &&
        mod?.parent_id === modifier.id
      ) {
        decremented = true
        return {
          ...mod,
          modifier_quantity: Math.max(
            mod.min_amount || 0,
            mod.modifier_quantity - 1
          ),
        }
      }
      return mod
    })
    setOrderModifiers(updatedModifiers)
  } else {
    setOrderModifiers(changedModifiers)
  }
}

export const onModifierChange: IModifierChangeParams = (
  checked,
  modifier,
  setOrderModifiers
) => {
  if (checked) {
    setOrderModifiers((prevState) =>
      prevState.map((el) =>
        el.modifier_id === modifier.id
          ? { ...el, modifier_quantity: modifier?.min_amount || 1 }
          : el
      )
    )
  } else {
    if (!modifier.is_compulsory) {
      setOrderModifiers((prevState: ISavedModifier[]) =>
        prevState.map((el) =>
          el.modifier_id === modifier.id ? { ...el, modifier_quantity: 0 } : el
        )
      )
    }
  }
}

const updateModifierQuantity = (
  modifiersQuantity: IModifierQuantityObj[],
  modifier: IGroupModifier,
  increment: number
) => {
  const updated = [...modifiersQuantity]
  const grModIdx = updated.findIndex((item) => item.id === modifier.id)

  if (grModIdx !== -1) {
    updated[grModIdx] = {
      ...updated[grModIdx],
      quantity: Math.max(0, (updated[grModIdx]?.quantity || 0) + increment),
    }
  }
  return updated
}

export const onGroupModifierChange: IGroupModifierChangeParams = (
  checked,
  variant,
  modifier,
  orderModifiers,
  setOrderModifiers,
  modifiersQuantity,
  setModifiersQuantity
) => {
  const grModIdx = modifiersQuantity.findIndex(
    (item) => item.id === modifier.id
  )
  const orderModifier = orderModifiers.find(
    (item) => item.modifier_id === variant.id
  )
  if (checked) {
    if (
      modifiersQuantity[grModIdx] &&
      modifiersQuantity[grModIdx]?.quantity < modifier.max_amount
    ) {
      setModifiersQuantity((prevState) =>
        updateModifierQuantity(prevState, modifier, 1)
      )
    } else {
      onModifierMaxAmount(modifier, variant, orderModifiers, setOrderModifiers)
    }
    if (!Boolean(orderModifier?.modifier_quantity)) {
      setOrderModifiers((prevState) =>
        prevState.map((el) =>
          el.modifier_id === variant.id ? { ...el, modifier_quantity: 1 } : el
        )
      )
    }
  } else {
    const mockModifierQuantity = modifiersQuantity.find(
      (item) => item.id === modifier.id
    )
    if (
      !modifier.is_compulsory ||
      ((mockModifierQuantity?.quantity || 0) > modifier.min_amount &&
        modifier.is_checkbox)
    ) {
      setOrderModifiers((prev) =>
        prev.map((el) =>
          el.modifier_id === variant.id ? { ...el, modifier_quantity: 0 } : el
        )
      )
      setModifiersQuantity((prevState) =>
        updateModifierQuantity(
          prevState,
          modifier,
          -(orderModifier?.modifier_quantity || 0)
        )
      )
    }
  }
}

export const onIncreaseModifierQuantity = (
  modifier: ISingleModifier,
  orderModifiers: ISavedModifier[],
  setOrderModifiers: React.Dispatch<React.SetStateAction<ISavedModifier[]>>
) => {
  const mockModifier = orderModifiers?.find(
    (item: ISavedModifier) => item.modifier_id === modifier.id
  )
  if (mockModifier && mockModifier?.modifier_quantity < modifier.max_amount) {
    setOrderModifiers((prev: ISavedModifier[]) =>
      prev.map((item) =>
        item.modifier_id === mockModifier.modifier_id
          ? {
              ...mockModifier,
              modifier_quantity: mockModifier.modifier_quantity + 1,
            }
          : item
      )
    )
  }
}
export const onIncreaseModifierVariantQuantity = (
  variant: IGroupModifierVariant,
  modifier: IGroupModifier,
  orderModifiers: ISavedModifier[],
  setOrderModifiers: React.Dispatch<React.SetStateAction<ISavedModifier[]>>,
  modifiersQuantity: IModifierQuantityObj[],
  setModifiersQuantity: React.Dispatch<
    React.SetStateAction<IModifierQuantityObj[]>
  >
) => {
  const mockModifier = orderModifiers.find(
    (item) => item.modifier_id === variant.id
  )

  if (mockModifier && mockModifier?.modifier_quantity < variant.max_amount) {
    const totalQuantity = modifiersQuantity.find(
      (item) => item.id === modifier.id
    )
    if (totalQuantity && totalQuantity?.quantity < modifier.max_amount) {
      setOrderModifiers((prev: ISavedModifier[]) =>
        prev.map((item) =>
          item.modifier_id === mockModifier.modifier_id
            ? {
                ...mockModifier,
                modifier_quantity: mockModifier.modifier_quantity + 1,
              }
            : item
        )
      )
      setModifiersQuantity((prev) =>
        prev.map((item) =>
          item.id === totalQuantity.id
            ? {
                ...totalQuantity,
                quantity: totalQuantity.quantity + 1,
              }
            : item
        )
      )
    } else {
      onModifierMaxAmount(modifier, variant, orderModifiers, setOrderModifiers)
    }
  }
}
export const onDecreaseModifierQuantity = (
  modifier: ISingleModifier,
  orderModifiers: ISavedModifier[],
  setOrderModifiers: React.Dispatch<React.SetStateAction<ISavedModifier[]>>
) => {
  const mockModifier = orderModifiers?.find(
    (item) => item.modifier_id === modifier.id
  )
  if (mockModifier && mockModifier?.modifier_quantity > modifier.min_amount) {
    setOrderModifiers((prev: ISavedModifier[]) =>
      prev.map((item) =>
        item.modifier_id === mockModifier.modifier_id
          ? {
              ...mockModifier,
              modifier_quantity: mockModifier.modifier_quantity - 1,
            }
          : item
      )
    )
  }
}
export const onDecreaseModifierVariantQuantity = (
  variant: IGroupModifierVariant,
  modifier: IGroupModifier,
  orderModifiers: ISavedModifier[],
  setOrderModifiers: React.Dispatch<React.SetStateAction<ISavedModifier[]>>,
  modifiersQuantity: IModifierQuantityObj[],
  setModifiersQuantity: React.Dispatch<
    React.SetStateAction<IModifierQuantityObj[]>
  >
) => {
  const mockModifier = orderModifiers.find(
    (item: ISavedModifier) => item.modifier_id === variant.id
  )
  if (mockModifier && mockModifier.modifier_quantity > variant.min_amount) {
    const totalQuantity = modifiersQuantity.find(
      (item) => item.id === modifier.id
    )
    if (totalQuantity && totalQuantity.quantity > modifier.min_amount) {
      setModifiersQuantity((prev) =>
        prev.map((item) =>
          item.id === totalQuantity.id
            ? {
                ...totalQuantity,
                quantity: totalQuantity.quantity - 1,
              }
            : item
        )
      )
      setOrderModifiers((prev: ISavedModifier[]) =>
        prev.map((item) =>
          item.modifier_id === mockModifier.modifier_id
            ? {
                ...mockModifier,
                modifier_quantity: mockModifier.modifier_quantity - 1,
              }
            : item
        )
      )
    }
  }
}
